import { render, staticRenderFns } from "./ActivationsInfo.vue?vue&type=template&id=0cf559df"
import script from "./ActivationsInfo.vue?vue&type=script&lang=js"
export * from "./ActivationsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports